export enum FrameCornerCondition {
  BTH = '(BTH) BUTT HEAD',
  BTJ = '(BTJ) BUTT JAMBS',
  DIE = '(DIE) DIE MITER',
  // SAW = '(SAW) SAW MITER',
}
